// import "../css/reset.css";
import "../scss/app.scss";
import "../css/app.css";
import "../css/custom.css";
import "../css/symplur.css";
import "../css/topnav.css";
import "../css/slick.css";
import "../css/slick-theme.css";
import "../css/modal-video.min.css";
import "../css/ekko-lightbox.css";
import "../css/redesign.css";
import "../css/stripe.css";
import "../../../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css";
// import "../../../node_modules/datatables.net-bs/css/dataTables.bootstrap.css";
import "../../../node_modules/odometer/themes/odometer-theme-default.css";
import "../../../node_modules/ladda/dist/ladda-themeless.min.css";
import "../../../node_modules/bootstrap-tagsinput/dist/bootstrap-tagsinput.css";

import "./mailchimp.js";
// import "./subbscribe.js";
import "./symplur-footer.js";
import "./symplur-twitter.js";
import "./symplur-typeahead.js";
import "./symplur.js";
import "./highcharts-symplur-theme.js";
import "./redesign.js";
import "./topnav.js";
import "./slick.js";
import "./ekko-lightbox.js";
import "./jquery-modal-video.js";
import "./jquery.mobile.custom.min.js";
import "./fontawesome.js";

import typeahead from "typeahead.js";
import bootstrap from "bootstrap";
import datetimepicker from "eonasdan-bootstrap-datetimepicker";
import particlesJS from "particles.js";
import Cookies from "js-cookie";
import Clipboard from "clipboard";
// import highcharts from "highcharts";
// import dataTables from "datatables.net-bs";
import odometer from "odometer";
import moment from "moment";
import tz from "moment-timezone";
import Ladda from "ladda";
import validator from "bootstrap-validator";
import tagsinput from "bootstrap-tagsinput";
import placeholder from "jquery-placeholder";
// import fontawesome from "@fortawesome/fontawesome-pro";
import lazySizes from 'lazysizes';
import "../../../node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks";

// window.highcharts = highcharts;
window.moment = moment;
window.Clipboard = Clipboard;
// window.dataTables = dataTables;
window.Cookies = Cookies;
window.Bloodhound = typeahead;
window.odometer = odometer;
window.Ladda = Ladda;
window.validator = validator;
window.tagsinput = tagsinput;
